import { useHook, useMutationHook } from '../utils/use-hook'
import { mutationFetcher } from '../utils/default-fetcher'
import type { MutationHook, HookFetcherFn } from '../utils/types'
import type { ActivateHook } from '../types/activate'
import type { Provider } from '..'

export type UseActivate<
  H extends MutationHook<ActivateHook<any>> = MutationHook<ActivateHook>
> = ReturnType<H['useHook']>

export const fetcher: HookFetcherFn<ActivateHook> = mutationFetcher

const fn = (provider: Provider) => provider.auth?.useActivate!

const useActivate: UseActivate = (...args) => {
  const hook = useHook(fn)
  return useMutationHook({ fetcher, ...hook })(...args)
}

export default useActivate
